import React from "react";
import ReactDOM from "react-dom";
import { Application } from "icerockdev-admin-toolkit";
import config from "~/config";

ReactDOM.render(<Application config={config} />, document.getElementById("root"));
